export default __webpack_public_path__ + "../configurator/jinja2//configurator/svg/aspect.svg";